import React from "react";
import PropTypes from "prop-types";
import ButtonRadio from "wonderbly-components/lib/ButtonRadio";
import Thumbnail from "../Thumbnail";

const DynamicBreadcrumbsNavItem = (props) => (
  <ButtonRadio
    disabled={!props.available}
    id={`${props.id}-${props.index}`}
    value={props.id}
    onChange={props.onChange}
    className="dynamic-breadcrumb-nav-item"
    name="characterSelection"
  >
    <div className="dynamic-breadcrumb-nav-item-inner">
      <Thumbnail src={props.url} alt={props.label} />
      <div className="dynamic-breadcrumb-nav-item-label">{props.label}</div>
      <div
        className={`button ${
          props.available ? "button--green" : "button--disabled"
        }`}
      >
        {props.available ? props.select : props.inUse}
      </div>
    </div>
  </ButtonRadio>
);

DynamicBreadcrumbsNavItem.propTypes = {
  available: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  url: PropTypes.string.isRequired,
  inUse: PropTypes.string.isRequired,
  select: PropTypes.string.isRequired,
};

export default DynamicBreadcrumbsNavItem;
